import React, { useEffect } from 'react';
import aboutImage from '../../assets/backgrounds/about.png';
import AboutSection from '../../components/AboutSection';
import './styles.css';

const About = () => {
  useEffect(() => {
    document.body.classList.add('about-page');
    return () => {
      document.body.classList.remove('about-page');
    };
  }, []);

  return (
    <div className="about-page">
      <div className="hero-section">
        <img src={aboutImage} alt="Sobre a JoviPlanet" />
        <div className="hero-content">
          <h1>Sobre Nós</h1>
          <p>Oferecemos locais únicos e adequados ao seu conforto</p>
        </div>
      </div>
      <AboutSection />
    </div>
  );
};

export default About; 